import { utils, writeFileXLSX } from 'xlsx';
import type { GlossaryTerm } from '../types';

function sanitizeFilenamePart(input: string): string {
  const forbidden = new Set(['<', '>', ':', '"', '/', '\\', '|', '?', '*']);
  let cleaned = '';
  for (const ch of input) {
    const code = ch.charCodeAt(0);
    cleaned += forbidden.has(ch) || code < 32 ? ' ' : ch;
  }
  const sanitized = cleaned.replace(/\s+/g, ' ').trim();
  return sanitized.length > 80 ? sanitized.slice(0, 80).trim() : sanitized;
}

function calcColWidths(rows: Array<Record<string, unknown>>, headers: string[]) {
  // Approximate width in "characters" (wch)
  return headers.map((h) => {
    const headerLen = h.length;
    const maxCellLen = rows.reduce((max, r) => {
      const v = r[h];
      const s = v === null || v === undefined ? '' : String(v);
      return Math.max(max, s.length);
    }, 0);
    const wch = Math.min(Math.max(headerLen, maxCellLen) + 2, 60);
    return { wch };
  });
}

export function exportGlossaryToXlsx(params: { terms: GlossaryTerm[]; seriesTitle?: string }) {
  const { terms, seriesTitle } = params;

  const rows = terms.map((t) => ({
    'Оригинальное название': t.source_term ?? '',
    'Русское название': t.ru_term ?? '',
    'Пол/Атрибут': t.attribute ?? '',
    'Описание': t.notes ?? '',
  }));

  const worksheet = utils.json_to_sheet(rows);
  const headers = ['Оригинальное название', 'Русское название', 'Пол/Атрибут', 'Описание'];
  worksheet['!cols'] = calcColWidths(rows, headers);

  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet, 'Глоссарий');

  const titlePart = seriesTitle ? `_${sanitizeFilenamePart(seriesTitle)}` : '';
  const filename = `glossary${titlePart}.xlsx`;
  writeFileXLSX(workbook, filename);
}



